// extracted by mini-css-extract-plugin
export default {"wrapper":"zURSQW96","mobileMenu":"Hcn5kfuG","menuContainer":"U5p9TgAH","menu":"Oy_Qv2Sm"};